import { CustomerPaymentMethodModel } from './../../../models/Profile/CustomerPaymentMethodModel';
import { AuthService } from 'src/app/services/auth.service';
import { EditPaymentInfoComponent } from './../edit-payment-info/edit-payment-info.component';
import { DeletePaymentInfoComponent } from './../delete-payment-info/delete-payment-info.component';
import { AddPaymentInfoComponent } from './../add-payment-info/add-payment-info.component';
import { BookingService } from './../../../services/booking.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { Customer } from 'src/app/models/Customer';

@Component({
  selector: 'view-payment',
  templateUrl: './view-payment.component.html',
  styleUrls: ['./view-payment.component.css']
})
export class ViewPaymentComponent implements OnInit {

  paymentForm: FormGroup;
  visaForm: FormGroup;
  chequeForm: FormGroup;
  ACHForm: FormGroup;

  submitted = false;

  paymentMethods;
  loggedInCustomer:Customer;

  constructor(
    private formBuilder: FormBuilder,
    private service: BookingService,
    private dialog: MatDialog,
    private authService: AuthService
  ) {
    //this.PaymentMethods = service.getPaymentMethod();
  }


  ngOnInit() {
    this.authService.loggedInCustomer.subscribe(res => {
      this.loggedInCustomer=res;
      this.getPaymentMethods(res.customerID);
    })
    this.paymentForm = this.formBuilder.group({
      FullAmount: ['', Validators.required],
      SecurityDeposit: ['', Validators.required],
    });
    this.visaForm = this.formBuilder.group({
      CardNumber: ['', Validators.required],
      Provider: ['', Validators.required],
      CardHolderName: ['', Validators.required],
      ExpiryMonth: ['', Validators.required],
      ExpiryYear: ['', Validators.required],
      CVC: ['', Validators.required],
    });
    this.chequeForm = this.formBuilder.group({
      ChequeNumber: ['', Validators.required],
      BankName: ['', Validators.required],
      ChequeDate: ['', Validators.required],
    });
    this.ACHForm = this.formBuilder.group({
      BankAccount: ['', Validators.required],
      BankName: ['', Validators.required],
      AccountName: ['', Validators.required],
      Routing: ['', Validators.required],
    });


  }

  // convenience getter for easy access to form fields
  get paymentInfo() { return this.paymentForm.controls; }
  get visaInfo() { return this.visaForm.controls; }
  get chequeInfo() { return this.chequeForm.controls; }
  get ACHInfo() { return this.ACHForm.controls; }

  getPaymentMethods(customerID) {
    this.authService.getCustomerPaymentMethods(customerID).subscribe(paymnets => {
      this.paymentMethods = paymnets;
      this.paymentMethods.forEach(element => {

        //The add and validation- should be done using a library to handle all cases for all cards
        let currentDate = new Date();
        let currnetYear = currentDate.getFullYear();
        let currentMonth = currentDate.getMonth() + 1;

        let yearString=currentDate.getFullYear()+"";
        if((element.expiryYear+"").length==2){
          element.expiryYear=Number(yearString.substring(0,2)+element.expiryYear);
        }

        if (element.expiryYear < currnetYear || (element.expiryYear == currnetYear && element.expiryMonth < currentMonth)) {
          element.expired = true;
        }
      });


    })
  }
  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.paymentForm.invalid) {
      return;
    }

    // display form values on success
    alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.paymentForm.value, null, 4));
  }

  onReset() {
    this.submitted = false;
    this.paymentForm.reset();
  }

  method: string = 'visa';
  changeComboo(event) {

  }

  /***New***/

  row = [
    {
      name: 'John Doe Junior',
      number: '859632569874',
      expired: '21/20/2020',
      status: 'Default',
    },
    {
      name: 'John Doe Junior',
      number: '859632569874',
      expired: '21/20/2020',
      status: 'Expired',
    },
    {
      name: 'John Doe Junior',
      number: '859632569874',
      expired: '21/20/2020',
      status: 'Expired',
    }
  ];

  // deleteCard(x){
  //   var delBtn = confirm(" Do you want to delete ?");
  //   if ( delBtn == true ) {
  //     this.row.splice(x, 1 );
  //   }
  // }

  editRow(index, payment: CustomerPaymentMethodModel) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data={
      customerPaymentMethod:payment
    }
    let dialogRef=this.dialog.open(EditPaymentInfoComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(
      data => {
        if (data != null && data.success) {
          this.getPaymentMethods(this.loggedInCustomer.customerID);
        }
      }
    );
  }

  deleteRow(index, payment: CustomerPaymentMethodModel) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      customerPaymentMethodID: payment.customerPaymentMethodID
    }
    let dialogRef = this.dialog.open(DeletePaymentInfoComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(
      data => {

        if (data != null && data.success) {
          this.paymentMethods.splice(index, 1);
        }


      }
    );
    // this.row.splice(x, 1 );
  }

  openAddPayment() {
    const dialogConfig = new MatDialogConfig();
    let dialogRef = this.dialog.open(AddPaymentInfoComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(
      data => {
        if (data != null && data.success) {
          this.getPaymentMethods(this.loggedInCustomer.customerID);
        }
      }
    );

  }




}

